import { render, staticRenderFns } from "./CotizacionRequerimientoFormComponent.vue?vue&type=template&id=0394c81c&"
import script from "./CotizacionRequerimientoFormComponent.vue?vue&type=script&lang=js&"
export * from "./CotizacionRequerimientoFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports